(function () {
  function initRotator(wrap) {
    if (wrap.dataset.rotatorInit) return;
    wrap.dataset.rotatorInit = '1';
    var words = Array.prototype.slice.call(wrap.querySelectorAll('[data-word]'));
    if (words.length < 2) {
      if (words[0]) words[0].classList.add('is-active');
      return;
    }
    var idx = 0;
    words[0].classList.add('is-active');
    setInterval(function () {
      var current = words[idx];
      var nextIdx = (idx + 1) % words.length;
      var next = words[nextIdx];
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      next.classList.add('is-active');
      setTimeout(function () {
        current.classList.remove('is-leaving');
      }, 400);
      idx = nextIdx;
    }, 2400);
  }

  function initToggle(formWrap, input) {
    if (input.dataset.toggleInit) return;
    input.dataset.toggleInit = '1';
    function update() {
      var hide = document.activeElement === input || input.value.length > 0;
      formWrap.classList.toggle('t4s-hide-animated-word', hide);
    }
    input.addEventListener('focus', update);
    input.addEventListener('blur', update);
    input.addEventListener('input', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-animated-search-words]').forEach(function (wrap) {
      var formWrap = wrap.closest('.t4s-search-header__form-wrap');
      var input = formWrap && formWrap.querySelector('[data-input-search]');
      if (!formWrap || !input) return;
      initRotator(wrap);
      initToggle(formWrap, input);
      formWrap.classList.add('t4s-has-animated-search');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
